module.exports = __webpack_public_path__ + "img/up-arrow.1febbb02.svg";